document.addEventListener('alpine:init', () => {
  var { getScript } = Alpine.store('utilities');

  function productFormActionsContainer(data = {}) {
    return {
      ...data,

      isEnabledKlaviyoBis: false,

      init() {
        Alpine.effect(() => {
          if (this.isEnabledKlaviyoBis) return;

          if (!this.selectedVariant.available) {
            this.initKlaviyoBis();
            
            this.isEnabledKlaviyoBis = true;
          }
        });
      },

      initKlaviyoBis() {
        var scriptUrl = 'https://a.klaviyo.com/media/js/onsite/onsite.js';

        getScript((scriptUrl), () => {
          klaviyo.init({
            account: 'v427in',
            platform: 'shopify'
          });
        
          klaviyo.enable('backinstock',{
            trigger: {
              product_page_text: 'Notify Me When Available',
              product_page_class: 'hide!',
              product_page_text_align: 'center',
              product_page_margin: '0px',
              replace_sold_out: false
            },
            modal: {
              headline: '{product_name}',
              body_content: 'Register to receive a notification when this item comes back in stock.',
              email_field_label: 'Email',
              button_label: 'Notify me when available',
              subscription_success_label: 'You\'re in! We\'ll let you know when it\'s back.',
              footer_content: '',
              close_label: 'Close',
              additional_styles: "@import url('https://fonts.googleapis.com/css?family=Helvetica+Neue');",
              font_family: '"Helvetica Neue", Helvetica, Arial, sans-serif;',
              drop_background_color: '#000',
              background_color: '#fff',
              text_color: '#222',
              button_text_color: '#fff',
              button_background_color: '#49c396',
              close_button_color: '#ccc',
              error_background_color: '#fcd6d7',
              error_text_color: '#C72E2F',
              success_background_color: '#d3efcd',
              success_text_color: '#1B9500'
            }
          });
        });
      }
    };
  };

  Alpine.data('productFormActionsContainer', productFormActionsContainer);
});
